<div class="row"
  style="width:100%; float: right; text-align: right; margin-top: 0px; padding-top: 0px; margin-right:0px !important">
  <div class="col-11"></div>
  <div class="col-1 text-right" style="float:right; margin-right:0px; padding-right:0px;">
    <mat-icon style="float:right; cursor: pointer;" (click)="onNoClick()">cancel</mat-icon>
  </div>
</div>
<h1 mat-dialog-title>{{labels.lblAddTraining}}</h1>
<div mat-dialog-content>
  <form (ngSubmit)="onSubmit()" #insertForm="ngForm" style="height: 435px !important;">
    <div fxLayout="column">
      <mat-form-field appearance="none" fxFlex="60%">
        <mat-label>{{labels.lblETrainingName}}</mat-label>
        <input matInput ngModel name="name" #name="ngModel" required>
        @if (err == true) {
          <mat-error style="margin-bottom:1.5vh !important;">{{labels.lblfieldRequired}}</mat-error>
        }
      </mat-form-field>
      <mat-form-field class="matFormField" appearance="none" fxFlex="60%">
        <textarea placeholder="{{labels.lblDescription}}" class="txtArea" matInput maxlength="750" rows="5" cols="5" ngModel name="description"
        #description="ngModel"></textarea>
        @if (err == true) {
          <!--<mat-error style="margin-bottom:1.5vh !important;">{{labels.lblfieldRequired}}</mat-error>-->
        }
      </mat-form-field>
      <mat-form-field appearance="none">
        <mat-label>{{labels.lblTrainer}}</mat-label>
        <mat-select ngModel name="trainerId" required>
          @for (trainer of trainers; track trainer) {
            <mat-option [value]="trainer._id">
              {{trainer.firstName}} {{trainer.lastName}}
            </mat-option>
          }
        </mat-select>
        @if (err == true) {
          <mat-error style="margin-bottom:1.5vh !important;">{{labels.lblfieldRequired}}</mat-error>
        }
      </mat-form-field>
      <!--<mat-form-field appearance="none">
        <mat-label>{{labels.lblPriority}}</mat-label>
        <mat-select ngModel name="priority" required>
          <mat-option [value]="1">
            1
          </mat-option>
          <mat-option [value]="2">
            2
          </mat-option>
          <mat-option [value]="3">
            3
          </mat-option>
        </mat-select>
      </mat-form-field>-->
      <!--<mat-form-field appearance="fill">
        <mat-label>{{labels.lblAvailableAfterTraining}}</mat-label>
        <mat-select [ngModel]="selectedTraining" name="availableAfterTraining">
          @for (training of otherTrainings; track training) {
            <mat-option [value]="training._id">
              {{ training.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>-->
      <mat-form-field appearance="none" fxFlex="60%">
        <mat-label>{{labels.lblTrainingTimeEstimation}}</mat-label>
        <input matInput pattern="[0-9]+" (input)="filterOnlyNumbers($event)" type="number"  name="duration" [(ngModel)]="duration" required/>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{labels.lblDateLimit}}</mat-label>
        <input ngModel name="toDate" matInput [matDatepicker]="toDate">
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="toDate"></mat-datepicker-toggle>
        <mat-datepicker #toDate></mat-datepicker>
      </mat-form-field>
      <!--<mat-checkbox
        appearance="none"
        class="example-margin checkbox"
        (click)="toggleIsTestOnly()">
        <mat-label>Da li je samo test?</mat-label>
      </mat-checkbox>-->
      @if (!selectedImage) {
        <mat-form-filed appearance="none" fxFlex="60%">
          <input type="file" (change)="onImageChanged($event)" #imageUpload style="display: none;" required>
          <button mat-raised-button class="noBtn" type="button"
          (click)="imageUpload.click()">{{labels.lblUploadImage}}</button>
        </mat-form-filed>
      }
      @if (selectedImage) {
        <mat-label>
          {{labels.lblImage}}: {{selectedImage.name}}
          <mat-icon style="float:right; cursor: pointer;" (click)="updateImage()">cancel</mat-icon>
        </mat-label>
      }

      <!-- fotografija za naslovnu stranu -->
      @if (!selectedImage2) {
        <mat-form-filed appearance="none" style = "margin-top: 15px;" fxFlex="60%">
          <input type="file" (change)="onImageChanged2($event)" #imageUpload2 style="display: none;" required>
          <button mat-raised-button class="noBtn" type="button"
          (click)="imageUpload2.click()">{{labels.lblUploadCoverImage}}</button>
        </mat-form-filed>
      }
      @if (selectedImage2) {
        <mat-label>
          {{labels.lblImage}}: {{selectedImage2.name}}
          <mat-icon style="float:right; cursor: pointer;" (click)="updateImage2()">cancel</mat-icon>
        </mat-label>
      }

      <div mat-dialog-actions>
        @if (uploading) {
          <mat-progress-bar mode="indeterminate" style="margin-top: 15px;"></mat-progress-bar>
        }
        <!-- <button class="noBtn" mat-button (click)="onNoClick()" type="button">{{labels.lblNo}}</button> -->
        <button class="btn" cdkFocusInitial type="submit" style="margin-top: 15px;">{{labels.lblAdd}}</button>
      </div>
    </div>
  </form>
</div>
